import React, { useEffect, useMemo, useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CommonDataTable from "../../components/CommonDataTable";

const rawColumns = [
    { field: "geoId", headerName: "Geo ID"},
    { field: "country", headerName: "Country"},
    { field: "state", headerName: "State"},
    { field: "city", headerName: "City"},
    { field: "pincodeDisplay", headerName: "Pincode"},
    { field: "createdBy", headerName: "Created By"},
    { field: "createdDate", headerName: "Created Date"},
    { field: "updatedBy", headerName: "Updated By"},
    { field: "updatedDate", headerName: "Updated Date" },
    
];

export default function GeographyList({
    geography,
    page,
    pageSize,
    setPage,
    setPageSize,
    onCreateClick,
    onView,
    onEdit,
    onRefresh
}) {
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const [menuRow, setMenuRow] = useState(null);
    const [tableRows, setTableRows] = useState([]);
    const [totalCount, setTotalCount] = useState(0);

    useEffect(() => {
        if (geography?.data?.length) {

            const formatted = geography.data.map((item) => {

                let pincodeDisplay = "";

                if (item.pincodeConfig?.type === "individual") {
                    pincodeDisplay = item.pincodeConfig.codes?.join(", ");
                }

                if (item.pincodeConfig?.type === "range") {
                    pincodeDisplay =
                        `${item.pincodeConfig.range?.from} - ${item.pincodeConfig.range?.to}`;
                }

                if (item.pincodeConfig?.type === "range_excluding") {
                    pincodeDisplay =
                        `${item.pincodeConfig.range?.from} - ${item.pincodeConfig.range?.to} 
             (Excl: ${item.pincodeConfig.exclude?.join(", ")})`;
                }

                return {
                    id: item._id, // DataGrid ke liye required
                    geoId: item.geoId,
                    country: item.country,
                    state: item.state,
                    city: item.city,
                    pincodeDisplay,
                    createdBy: item.createdBy,
                    createdDate: item.createdDate,
                    updatedBy: item.updatedBy,
                    updatedDate: item.updatedDate,
                    __original: item
                };
            });

            setTableRows(formatted);
            setTotalCount(geography.meta?.total || 0);
        }
    }, [geography]);

    const actionColumn = {
        field: "__actions",
        headerName: "",
        width: 80,
        sortable: false,
        renderCell: (params) => (
            <IconButton
                size="small"
                onClick={(e) => {
                    e.stopPropagation();
                    setMenuAnchorEl(e.currentTarget);
                    setMenuRow(params.row);
                }}
            >
                <MoreVertIcon fontSize="small" />
            </IconButton>
        )
    };

    const allColumns = useMemo(
        () => [actionColumn, ...rawColumns],
        []
    );

    return (
        <>
            <CommonDataTable
                checkboxSelection
                allPossibleColumns={allColumns}
                initialVisible={allColumns.map((c) => c.field)}
                initialRows={tableRows}
                height={520}
                rowsPerPageOptions={[10, 25, 50]}
                showCreateButton
                createButtonText="Create New"
                onCreateClick={onCreateClick}

                forInventory={true} 

                onDataRefresh={onRefresh}


                page={page}
                pageSize={pageSize}
                rowCount={totalCount}
                onPageChange={(newPage) => setPage(newPage)}
                onPageSizeChange={(newSize) => {
                    setPageSize(newSize);
                    setPage(0);
                }}
            />

            <Menu
                open={!!menuAnchorEl}
                anchorEl={menuAnchorEl}
                onClose={() => setMenuAnchorEl(null)}
            >
                <MenuItem onClick={() => onView(menuRow.__original)}>
                    View
                </MenuItem>
                <MenuItem onClick={() => onEdit(menuRow.__original)}>
                    Edit
                </MenuItem>
            </Menu>
        </>
    );
}
